import { render } from "./WorkWithUsQuotes.vue?vue&type=template&id=051cc8f5"
import script from "./WorkWithUsQuotes.vue?vue&type=script&lang=js"
export * from "./WorkWithUsQuotes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__